<se-fe-card>
  <se-fe-card-header
    seFeDataTitle="Feature: Child Info"
    seFeDataSubtitle="Adding a Child"
  ></se-fe-card-header>
  <se-fe-card-content>
    <se-po-household-setup-feature-child-info></se-po-household-setup-feature-child-info>
  </se-fe-card-content>
</se-fe-card>
